// Module
var code = `<div class="page-item--split-feature">
  {{#rows}}
  <div class="split-row">
    <div class="split-media">
      <img class="split-img" alt="{{headline}}" src="{{attrImageSrc}}" />
    </div>
    <div class="split-copy">
      <h3 class="split-headline">{{headline}}</h3>
      <p class="split-text">{{text}}</p>
      <a class="split-cta btn btn-primary" href="{{ctaHref}}">{{ctaText}}</a>
    </div>
  </div>
  {{/rows}}
</div>
`;
// Exports
module.exports = code;